
export class StudySchemaEventCode  {
    constructor(
        public id: number | null,
        public keyEventMappingId: number | null,
        public code: string | null,
        public name: string | null,
    ) { }
}